import { Command } from '../../Command';

export class UpdateDocumentStyleCommand extends Command {
  private styleToUpdate: string;
  private options: Editor.Edition.StylesCommandOptions;

  constructor(
    context: Editor.Edition.Context,
    styleId: string,
    options: Editor.Edition.StylesCommandOptions = {},
  ) {
    super(context);
    this.styleToUpdate = styleId;
    this.options = {
      applySelection: false,
      createPatch: true,
      untrackedActionWarning: true,
      ...options,
    };
  }

  async updateDocumentStyleFromRange(ctx: Editor.Edition.ActionContext) {
    if (
      !this.context.DataManager ||
      !this.context.contentManipulator ||
      !this.context.stylesManager
    ) {
      return;
    }

    const docStyleStatus =
      this.context.stylesManager.documentStyles.getDocumentStyleStatusFromRange(ctx.range);

    this.debugMessage(
      '[UpdateDocumentStyleCommand] updateDocumentStyleFromRange new styles',
      docStyleStatus,
    );

    if (docStyleStatus) {
      // update doc style
      await this.context.contentManipulator.updateDocumentStyle(
        this.styleToUpdate,
        docStyleStatus.p,
      );

      // check if needs to apply style
      if (docStyleStatus.id !== this.styleToUpdate) {
        // call apply style command
        await this.context.stylesManager.documentStyles.applyDocumentStyleToSelection(
          this.styleToUpdate,
          ctx.range,
          {
            applySelection: false,
            createPatch: false,
            resetParagraphStyle: false,
            untrackedActionWarning: false,
          },
        );
      }
    }
  }

  protected async handleExec(...args: any[]): Promise<void> {
    this.debugMessage('[UpdateDocumentStyleCommand] exec', this);

    // if (!this.documentStylesManager?.style(this.styleToApply)) {
    //   throw new Error('Style does not exist!');
    // }

    if (this.options.untrackedActionWarning && !this.askUserAboutThis()) {
      return;
    }

    this.buildActionContext();

    if (!this.actionContext) {
      throw new Error('Context is not defined');
    }

    await this.updateDocumentStyleFromRange(this.actionContext);

    //trigger seelction check
    this.checkSelectionStatus();

    if (this.options.createPatch) {
      this.createPatch();
    }
  }
}
